import { Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FeedbackService } from "../../../services/feedback.service";

@Component({
  selector: "app-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["./feedback.component.scss"],
})
export class FeedbackComponent {
  categories = [
    "Work-Life Balance",
    "Communication and Collaboration",
    "Compensation and Benefits",
    "Career Growth and Development",
    "Work Environment",
    "Job Security and Stability",
    "Management Support",
    "Recognition and Appreciation",
  ];

  @ViewChild("feedbackModal") feedbackModal: any;
  feedbackForm: FormGroup;
  ratings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private feedbackService: FeedbackService
  ) {
    this.feedbackForm = this.fb.group({
      category: ["", Validators.required],
      rating: ["", Validators.required],
      comments: ["", Validators.required],
    });
  }

  openModal() {
    this.modalService.open(this.feedbackModal, { centered: true });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onSubmit() {
    if (this.feedbackForm.valid) {
      this.feedbackService
        .submitFeedback(this.feedbackForm.value)
        .subscribe((response) => {
          console.log("Feedback submitted", response);
          this.closeModal();
        });
    }
  }
}
